import { useRef, useCallback } from "react";

export const useEventOnce = (onEvent) => {
  const triggeredRef = useRef(false);

  const handleEventOnce = useCallback((...args) => {
    if (triggeredRef.current) {
      return;
    }
    triggeredRef.current = true;
    onEvent(...args);
  }, []);

  return {
    handleEventOnce,
  };
};